(function () {
    const pxPerSecond = 50;

    document.querySelectorAll('.e-ticker__track').forEach(function (track, index) {
        const half = track.scrollWidth / 2;
        const duration = half / pxPerSecond;
        const name = `ticker-scroll-${index}`;
        const keyframes = `@keyframes ${name} { 100% { transform: translateX(-${half}px); } }`;
        const style = document.createElement("style");
        style.textContent = keyframes;
        document.head.appendChild(style);
        track.style.animationName = name;
        track.style.animationDuration = `${duration}s`;
    });
})();
